/* The mockup's `.steps-v` (numbered steps) and `.enrol` (QR beside the key). */
.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: step;
}

.steps > li {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: var(--space-3);
  counter-increment: step;
}

.steps > li::before {
  content: counter(step);
  display: grid;
  place-items: center;
  inline-size: 24px;
  block-size: 24px;
  border-radius: 50%;
  background: var(--surface-sunken);
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-semibold);
}

.stepTitle {
  font-weight: var(--font-weight-medium);
}

.enrol {
  display: grid;
  grid-template-columns: 176px minmax(0, 1fr);
  gap: var(--space-6);
  align-items: start;
  margin-block-start: var(--space-3);
}

@media (max-width: 640px) {
  .enrol {
    grid-template-columns: minmax(0, 1fr);
  }
}

.secretRow {
  display: flex;
  gap: var(--space-2);
}

.secret {
  flex: 1;
  display: flex;
  align-items: center;
  min-block-size: 32px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface-sunken);
  font-family: var(--font-mono, monospace);
  font-size: var(--font-size-13);
  letter-spacing: 0.08em;
  word-break: break-all;
}
